import classNames from 'classnames'

import type { ReactNode, ReactElement, PropsWithChildren } from 'react'

import './styles.scss'

interface Props {
  className?: string
  icon?: ReactNode
  menu?: ReactNode
  title: ReactNode
}

const DetailSection = ({ children, className, icon, menu, title }: PropsWithChildren<Props>): ReactElement => {
  return (
    <div className={classNames('detail-section-container', className)}>
      <div className="detail-section-header">
        {icon ? <div className="detail-section-header__icon">{icon}</div> : null}
        <div className="detail-section-header__title">{title}</div>
        {menu}
      </div>
      <div className="fields-container">{children}</div>
    </div>
  )
}

export default DetailSection
